// FE-21 — topes del adjunto de chat (openapi.yaml `/conversations/{id}/messages`):
// imagen 10 MiB, video 50 MiB. Rechazar en el cliente ahorra una subida de
// hasta 50 MiB que el backend va a tirar con 413.
const ALLOWED_ATTACHMENT_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/webp', 'video/mp4'];
const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
const MAX_VIDEO_BYTES = 50 * 1024 * 1024;

/** `null` si el archivo pasa; si no, el mensaje que se le muestra al usuario. */
export function validarAdjuntoChat(file: File): string | null {
  if (!ALLOWED_ATTACHMENT_TYPES.includes(file.type)) {
    return 'Formato no admitido: solo JPG, PNG, HEIC, WEBP o MP4.';
  }
  const esVideo = file.type.startsWith('video/');
  const tope = esVideo ? MAX_VIDEO_BYTES : MAX_IMAGE_BYTES;
  if (file.size > tope) {
    return esVideo ? 'El video supera el tope de 50 MB.' : 'La imagen supera el tope de 10 MB.';
  }
  return null;
}

export function formatearBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Traduce un `ApiError` del chat a algo que una persona pueda leer. */
export function mensajeErrorChat(err: unknown): string {
  const status = (err as { status?: number })?.status;
  const detail = (err as { detail?: string })?.detail;

  if (status === 403) return 'No participas en esta conversación.';
  if (status === 404) return 'La conversación o el mensaje ya no existen.';
  if (status === 413) return 'El adjunto supera el tope de tamaño (10 MB imagen, 50 MB video).';
  if (status === 415) return 'Tipo de archivo no admitido.';
  if (status === 400) return detail ?? 'El mensaje no puede estar vacío.';
  return detail ?? 'No se pudo enviar. Inténtalo de nuevo.';
}
